import React, { useState, useContext } from "react";
import { Row, Col, Button, Modal, Dropdown, ListGroup } from "react-bootstrap";
import renderHTML from "react-render-html";
import EditDocument from "./EditDocument";
import Context from "../Context";
import { CopyToClipboard } from "react-copy-to-clipboard";
import htmlToText from "html-to-text";
import "react-confirm-alert/src/react-confirm-alert.css";

export default ({ document, citeproc, updated, removed }) => {
  const context = useContext(Context);

  const [show_detail_modal, set_show_detail_modal] = useState(false);
  const [show_edit_modal, set_show_edit_modal] = useState(false);
  // const [copied, set_copied] = useState(false);
  const removeItem = () => {
    context.showConfirmationModal(
      "حذف سند",
      "آیا از حذف این سند اطمینان دارید؟",
      [
        {
          label: "بله",
          onClick: removed,
          variant: "danger",
        },
        {
          label: "خیر",
          onClick: () => {},
        },
      ]
    );
  };
  return (
    <ListGroup.Item
      style={{
        direction: (document.language || "fa") === "fa" ? "rtl" : "ltr",
        textAlign: (document.language || "fa") === "fa" ? "right" : "left",
      }}>
      <div className="results">
        <div
          style={{
            direction: (document.language || "en") === "en" ? "ltr" : "rtl",
            textAlign: (document.language || "en") === "en" ? "left" : "right",
            marginLeft: 30,
          }}>
          {renderHTML(citeproc.bibliography)}
        </div>
      </div>
      <Dropdown
        className="cite__hide-drop"
        style={{
          display: "inline-block",
          position: "absolute",
          left: -3,
          top: 3,
          borderRadius: 0,
          marginTop: 4,
        }}>
        <Dropdown.Toggle variant="defualt" id="dropdown-basic">
          <i className="fa fa-bars" aria-hidden="true"></i>
        </Dropdown.Toggle>
        <Dropdown.Menu>
          <Dropdown.Item
            onClick={() => {
              set_show_detail_modal(true);
            }}>
            <i className="fa fa-eye" aria-hidden="true"></i> مشاهده جزئیات
          </Dropdown.Item>
          <Modal
            show={show_detail_modal}
            style={{ zIndex: 9999 }}
            className="csl-modal"
            onHide={() => {
              set_show_detail_modal(false);
            }}>
            <Modal.Header closeButton>
              <Modal.Title>مشاهده جزئیات</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Row>
                <Col
                  className="cite__inLineCite"
                  style={{
                    direction:
                      (document.language || "fa") === "fa" ? "rtl" : "center",
                  }}
                  md={12}>
                  استناد درون‌متن:
                </Col>
                <Col
                  className="cite__inLineCiteOut"
                  style={{
                    direction:
                      (document.language || "fa") === "fa" ? "rtl" : "ltr",
                  }}
                  md={12}>
                  {renderHTML(citeproc.citation)}
                </Col>
                <Col
                  className="cite__outLineCite"
                  style={{
                    direction:
                      (document.language || "fa") === "fa" ? "rtl" : "center",
                  }}
                  md={12}>
                  استناد برون‌متن:
                </Col>
                <Col
                  style={{
                    direction:
                      (document.language || "fa") === "fa" ? "rtl" : "ltr",
                  }}
                  md={12}>
                  {renderHTML(citeproc.bibliography)}
                </Col>
              </Row>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="primary"
                onClick={() => {
                  set_show_detail_modal(false);
                }}>
                تایید
              </Button>
            </Modal.Footer>
          </Modal>
          <Dropdown.Item
            onClick={() => {
              set_show_edit_modal(true);
            }}>
            <i className="fa fa-pencil" aria-hidden="true"></i> ویرایش
          </Dropdown.Item>
          <EditDocument
            document={document}
            updated={updated}
            set_show={set_show_edit_modal}
            show={show_edit_modal}
            style={{ zIndex: 9999 }}
          />
          <CopyToClipboard
            text={htmlToText.fromString(citeproc.bibliography, {
              wordwrap: 99999,
            })}
            onCopy={() => {
              // set_copied(true);
            }}>
            <Dropdown.Item>
              <i className="fa fa-copy" aria-hidden="true"></i> کپی
            </Dropdown.Item>
          </CopyToClipboard>
          <Dropdown.Item onClick={removeItem}>
            <i className="fa fa-trash-o" aria-hidden="true"></i> حذف
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    </ListGroup.Item>
  );
};
